import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { messagesApi } from "../../../features/messages/messagesApi";
import Loading from "../../ui/Loading";
import Message from "./Message";

export default function Messages({ messages = [], id: paramsId }) {
  const { user } = useSelector((state) => state.auth) || {};
  const { email } = user || {};
  const totalCount = messages.filter(
    (msg) => msg.conversationId == paramsId
  ).length;
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  console.log(totalCount);
  const fetchMore = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(
        messagesApi.endpoints.getMoreMessages.initiate({
          id: paramsId,
          page,
        })
      );
    }
  }, [page, email, dispatch]);

  useEffect(() => {
    if (totalCount > 0) {
      const more =
        Math.ceil(
          totalCount / Number(process.env.REACT_APP_CONVERSATIONS_PER_PAGE)
        ) > page;

      setHasMore(more);
    }
  }, [totalCount, page]);
  return (
    <div
      id="scrollableDiv"
      className="relative w-full h-[calc(100vh_-_197px)] p-6 overflow-y-auto flex flex-col-reverse"
    >
      <InfiniteScroll
        dataLength={messages.length}
        next={fetchMore}
        inverse={true}
        hasMore={hasMore}
        scrollableTarget="scrollableDiv"
      >
        {loading && <Loading />}
        {messages
          .slice()
          .sort((a, b) => a.timestamp - b.timestamp)
          .map((message) => {
            const {
              message: lastMessage,
              id,
              sender,
              receiver,
              conversationId,
            } = message || {};

            const justify = sender.email !== email ? "start" : "end";
            const color =
              sender.email !== email ? "bg-blue-600" : "bg-slate-900";
            if (paramsId == conversationId) {
              return (
                <Message
                  key={id}
                  justify={justify}
                  message={lastMessage}
                  color={color}
                  sender={sender}
                />
              );
            }
            return null;
          })}
      </InfiniteScroll>
    </div>
  );
}
